//import $ from 'jquery';

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    showMessage() {
        // JavaScript to be fired on the home page using data-action property
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};
